/* eslint-disable react-hooks/rules-of-hooks */
/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/
/* eslint-disable no-unused-expressions */

import React, { useContext, useEffect, useRef, useState } from "react";
import { useHistory } from 'react-router-dom';
import { Field, Form, Formik } from 'formik';
import { Col, Row } from "components/Grid";
import Layout from "components/Layout/index";
import StepNavigation from "components/StepNavigation";
import ContentCard from "components/ContentCard";
import Button, { ButtonContainer } from 'components/Button';
import FileModal from "components/FileModal";
import BrokingSummary from "components/BrokingSummary";
import ClaimsSummary from 'components/ClaimsSummary';
import TextField from 'components/Form/TextField';
import Loader from 'components/Loader';
import Colors from 'constants/Colors';
import FilesAttachment from "components/FilesAttachment";
import FormContainer from 'components/FormContainer';
import { InputField } from "components/Form/index";
import { ButtonContent, NewRowAttchments, TextUnderscore } from "./styles";
import { GlobalAuthContext, GlobalLoaderContext } from 'store/context';
import { FitinsurAPI, MessageCenter } from 'utils';
import RenderButtons from 'components/RenderButtons';
import HasPermission from "components/HasPermission/index";
import DragZoneUpload from 'components/DragZoneUpload';
import TagsList3 from "components/TagList3";
import { Label } from "components/Form";
import ComboBox from 'components/Form/ComboBox3';
import MasksHelper from 'utils/src/masks';
import IMask from 'imask';
import { useHeaderNbi } from 'services/QuoteService'; 
import { usePaymentPackHtmlModal, useGetAttachmentsPaymentPack, usePaymentConfigurationForm, usePaymentPackSendApproval, usePaymentSendFramework} from 'services/PaymentPackService'

export default function SendInvoice(props) {
  const [file, setFile] = useState();
  const [summary, setSummary] = useState({});
  const [endorsmentType, setEndorsmentType] = useState("");
  const [isClaims, setIsClaims] = useState(false);
  const [statusEndorsement, setStatusEndorsement] = useState({
    title: "Payment Pack",
    route: "",
  });
  const [attachments, setAttachments] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [attachmentsUploaded, setAttachmentsUploaded] = useState([]);
  const [mrcQuestions, setMrcQuestions] = useState([]);
  const [searchList, setSearchList] = useState([]);
  const [mrcPercentages, setMrcPercentages] = useState([]);

  const authContext = useContext(GlobalAuthContext);
  const formik = useRef(null);
  const history = useHistory();
  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();
  const loading = useContext(GlobalLoaderContext);
  const maskHelper = new MasksHelper();

  const {
    data: useHeaderNbiData,
    loading: useHeaderNbiLoading,
    error: useHeaderNbiError,
    status: useHeaderNbiStatus,
    request: useHeaderNbiRequest,
  } = useHeaderNbi();

  const {
    data: usePaymentPackHtmlModalData,
    loading: usePaymentPackHtmlModalLoading,
    error: usePaymentPackHtmlModalError,
    status: usePaymentPackHtmlModalStatus,
    request: usePaymentPackHtmlModalRequest,
  } = usePaymentPackHtmlModal(props.match.params.idOperation);

  const {
    data: useGetAttachmentsPaymentPackData,
    loading: useGetAttachmentsPaymentPackLoading,
    error: useGetAttachmentsPaymentPackError,
    status: useGetAttachmentsPaymentPackStatus,
    request: useGetAttachmentsPaymentPackRequest,
  } = useGetAttachmentsPaymentPack(props.match.params.idOperation);

  const {
    data: usePaymentConfigurationFormData,
    loading: usePaymentConfigurationFormLoading,
    error: usePaymentConfigurationFormError,
    status: usePaymentConfigurationFormStatus,
    request: usePaymentConfigurationFormRequest,
  } = usePaymentConfigurationForm(props.match.params.idOperation);

  const {
    data: usePaymentPackSendApprovalData,
    loading: usePaymentPackSendApprovalLoading,
    error: usePaymentPackSendApprovalError,
    status: usePaymentPackSendApprovalStatus,
    request: usePaymentPackSendApprovalRequest,
  } = usePaymentPackSendApproval();

  const {
    data: usePaymentSendFrameworkData,
    loading: usePaymentSendFrameworkLoading,
    error: usePaymentSendFrameworkError,
    status: usePaymentSendFrameworkStatus,
    request: usePaymentSendFrameworkRequest,
  } = usePaymentSendFramework();

  useEffect(() => {
    if (useHeaderNbiLoading || usePaymentPackHtmlModalLoading || useGetAttachmentsPaymentPackLoading || usePaymentConfigurationFormLoading || usePaymentPackSendApprovalLoading || 
      usePaymentSendFrameworkLoading) {
      loading.start();
    } else {
      loading.stop();
    }
  }, [useHeaderNbiLoading, usePaymentPackHtmlModalLoading, useGetAttachmentsPaymentPackLoading, usePaymentConfigurationFormLoading, usePaymentPackSendApprovalLoading, 
    usePaymentSendFrameworkLoading]);

  function handleSummary() {
    useHeaderNbiRequest({idOperation: props.match.params.idOperation}, null).then(({data}) => {
      setSummary({
          typeOfCover: data.ret_value.typeOfCover,
          client: data.ret_value.client,
          obligorCoding: data.ret_value.obligorCoding,
          responseBy: data.ret_value.responseBy,
          internalContact: data.ret_value.internalContact,
          broker: data.ret_value.broker,
          dealCode: data.ret_value.deal,
          nmFacility: data.ret_value.nmFacility,
          nmObligor: data.ret_value.nmObligor,
          isFramework: data.ret_value.isFramework,
          projectName: data.ret_value.projectName,
          idOperation: props.match.params.idOperation,
        });
        setEndorsmentType(data.ret_value.endorsmentType)
      })
      .catch((error) => {
        mc.error("There was an error while fetching your data\n" + error);
      });
  };

  function handleSendApproval() {
    if(!formik.current.values.paymentPackMessage) {
      mc.error("Please fill in the field: Message - (Internal)");
      return;
    }

    usePaymentPackSendApprovalRequest({idOperation: props.match.params.idOperation, policyPackMessage: formik.current.values.paymentPackMessage}, null).then(({data}) => {
        if (data.ret_code !== 200) {
          mc.error(data.ret_msg_details);
          return;
        }

        return isClaims ? history.push('/claims') : history.push('/policies');
      })
      .catch((error) => {
        mc.error("There was an error while fetching your data\n" + error);
      });
  }

  function handleAttachments() {
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestPostAttachmentsPaymentPack(props.match.params.idOperation, attachments)
      .then(resp => resp.json())
      .then(data => {
        if (data.ret_code !== 200) {
          loading.stop();
          mc.error(data.ret_msg_details);
          return;
        }
        loading.stop();
        setAttachments([]);
        setUploading(false);
        handleGetAttachments()
      }).catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleAttachments.name}\n` + error);
      });
  }

  function handleGetAttachments() {
    useGetAttachmentsPaymentPackRequest().then(({data}) => {
        if (data.ret_code !== 200) {
          mc.error(data.ret_msg_details);
          return;
        }
        setAttachmentsUploaded(data.ret_value)
      }).catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleGetAttachments.name}\n` + error);
      });
  }

  function handleSendFramework() {    
    usePaymentSendFrameworkRequest({idOperation: props.match.params.idOperation}).then(({data}) => {
        if (data.ret_code !== 200) {
          mc.error(data.ret_msg_details);
          return;
        }

        return history.push('/policies');
      })
      .catch((error) => {
        mc.error("Erro executando consulta\n" + error);
      });
  }

  function handleFile() {
    usePaymentPackHtmlModalRequest().then(({data: resp}) => {
        if (resp.ret_code === 200) {
          setFile(resp.ret_value.paymentPackDocs)
        } else {
          mc.error(resp.ret_msg_details);
        }
      }).catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleFile.name}\n` + error);
      });
  };

  const fieldRenderOptionsOther = function (answerOptions) {
    let result = []
    answerOptions.forEach(element => {
      result.push({
        label: element.answerOptionDescription,
        value: {
          idAnswerOption: element.idAnswerOption,
          answerOptionDescription: element.answerOptionDescription
        }
      });
    });
    return result;
  }

  const verifyOptions = (fieldName) => {
    if (!mrcQuestions) {
      return;
    }

    return fieldRenderOptionsOther(mrcQuestions.answerOptions)
  };

  function getPaymentConfigurationForm() {
    usePaymentConfigurationFormRequest().then(({data: response}) => {
        if (response.ret_code != 200) {
          mc.error(response.ret_msg_details);
          history.goBack();
          return;
        }

        setIsClaims(response.ret_value.isClaims);
        const isArrayMrcPercentageAnswer = Array.isArray(response.ret_value?.mrcPercentages?.answer);
        const settlementDateAnswer = response.ret_value?.paymentConfigurationQuestions?.find(x => x.dsQuestion == 'Settlement Date')?.answer
        const paymentDateAnswer = response.ret_value?.paymentConfigurationQuestions?.find(x => x.dsQuestion == 'Payment Date')?.answer
        const mrcQuestions = response.ret_value?.mrcObligorCodings;
        const mrcPercentageAnswers = response.ret_value?.mrcPercentages || [];
        const obligorCodingTotal = isArrayMrcPercentageAnswer ? response.ret_value?.mrcPercentages?.answer.reduce((acc, item) => parseFloat(acc) + parseFloat(item), 0) : '';
        
        setMrcQuestions(mrcQuestions || [{ answerOptionDescription: '', idAnswerOption: '' }]);
        setMrcPercentages(mrcPercentageAnswers)

        if (formik.current) {
          formik.current?.setFieldValue('settlementDate', settlementDateAnswer)
          formik.current?.setFieldValue('paymentDate', paymentDateAnswer)
          formik.current?.setFieldValue('ObligorCoding',  mrcQuestions && Array.isArray(mrcQuestions.answer) ? mrcQuestions?.answer.map(ad => ad) : [],)
          formik.current?.setFieldValue('ObligorCodingPercentage',  mrcPercentageAnswers && Array.isArray(mrcPercentageAnswers.answer) ? mrcPercentageAnswers?.answer.map(ad => `% ${parseFloat(ad).toFixed(5)}`) : [],)
          formik.current?.setFieldValue('ObligorCodingTotal', obligorCodingTotal);
        }

      }).catch((error) => {
        mc.error(`There was an error while fetching your data: ${getPaymentConfigurationForm.name}\n` + error);
      });
  }

  function handlePaymentConfig() {
    history.push(`/broking/payment-pack-configuration/${props.match.params.idOperation}`)
  };

  const goToLoginPage = () => {
    history.push('login');
  };

  useEffect(() => {

    fitinsur.setAuthToken(authContext.token);

    getPaymentConfigurationForm();
    handleFile();
    handleSummary();
    handleGetAttachments();
  }, [])

  useEffect(() => {
    if (endorsmentType === 'pre-agreed') {
      setStatusEndorsement({
        title: "ENDORSEMENT - ANNIVERSARY: PREMIUM PRE AGREED / PAYMENT PACK",
        route: ''
      })
    } else if (endorsmentType === 'not-pre-agreed') {
      setStatusEndorsement({
        title: "ENDORSEMENT - ANNIVERSARY: PREMIUM NOT PRE AGREED / PAYMENT PACK",
        route: ''
      })
    } else if (endorsmentType === 'off-risk') {
      return;
    } else if (endorsmentType === 'cancellation') {
      setStatusEndorsement({
        title: "ENDORSEMENT - CANCELLATION / PAYMENT PACK",
        route: ''
      })
    } else if (endorsmentType === 'market-changes') {
      setStatusEndorsement({
        title: "RISK & MASKET CHANGES / PAYMENT PACK",
        route: ''
      })
    }
  }, [endorsmentType])

  function handlePaymentConfiguration() {
    history.push(`/broking/payment-pack-configuration/${props.match.params.idOperation}`)
  };

  const removeAttachment = item => {
    let elementToRemove, newAttachments;

    elementToRemove = attachments.find((att, index) => index === item);
    newAttachments = attachments.filter(attachment => attachment.documentId !== elementToRemove.documentId);
    setAttachments(newAttachments);

  }

  return (
    <Layout
      idOperation={props.match?.params?.idOperation}
      title={summary.projectName ? summary.projectName : summary.nmObligor ? summary.nmObligor : "Broking name"}
      subtitle={summary.dealCode ? summary.dealCode : "Broking code"}
    >

      {isClaims ? <ClaimsSummary stage={3} idOperation={props.match?.params?.idOperation} />
        : <>
          <StepNavigation stage={3} idOperation={props.match?.params?.idOperation} />
          <BrokingSummary data={summary} />
        </>}

      <ContentCard title={statusEndorsement.title}
        icon info={{ idOperation: props.match?.params?.idOperation || null, idProduct: props.location?.state?.idProduct || null }}>
        <Formik
          innerRef={formik}
          initialValues={{
            paymentPackMessage: ''
          }}
          onSubmit={handleSendApproval}
        >
          {formikProps => (
            <Form>
              {!summary.isFramework && <Row>
                <Col>
                  <Field
                    label={'Message - (Internal)'}
                    name={'paymentPackMessage'}
                    value={formikProps.values.paymentPackMessage}
                    onChange={(e) => formikProps?.setFieldValue('paymentPackMessage', e)}
                    component={TextField}
                  />
                </Col>
              </Row>}

              <Row>
                {formikProps.values.paymentDate &&
                  <Col md={3}>
                    <Field
                      disabled
                      name="paymentDate"
                      label="Payment Date"
                      placeholder="Payment Date"
                      type="text"
                      rightIcon="calendar"
                      rightIconClick={() => { }}
                      component={InputField}
                      value={formikProps.values.paymentDate}
                      onChange={() => { }}
                      canGenerate={false}
                    />
                  </Col>
                }

                {formikProps.values.settlementDate &&
                  <Col md={3}>
                    <Field
                      disabled
                      name="settlementDate"
                      label="Settlement Date"
                      placeholder="Settlement Date"
                      type="text"
                      rightIcon="calendar"
                      rightIconClick={() => { }}
                      component={InputField}
                      value={formikProps.values.settlementDate}
                      onChange={() => { }}
                      canGenerate={false}
                    />
                  </Col>
                }
              </Row>
              
              
              {mrcQuestions.answer && mrcQuestions?.answer.map((coverage, index) => (
                  <>
                    <Row>
                      <Col xs={12} md={2} lg={2}>
                        <Field
                          name={`ObligorCoding.${index}`}
                          label={index === 0 ? 'Obligor Coding' : '\u00A0'}
                          type="text"
                          placeholder="Select"
                          component={ComboBox}
                          options={verifyOptions('Obligor Coding')}
                          searchList={searchList}
                          disabled
                          />
                      </Col>

                      <Col xs={12} md={2} lg={2}>
                        <Field
                          name={`ObligorCodingPercentage.${index}`}
                          mask={maskHelper.getPercentage(authContext.region, 5)}
                          label="&nbsp;"
                          type="text"
                          component={InputField}
                          disabled
                        />

                      </Col>
                    </Row>
                  </>
                ))}
                {mrcQuestions.answer && (
                  <Row>
                    <Col xs={12} md={2} lg={2}/>
                    <Col xs={12} md={2} lg={2}>
                      {formikProps.values.ObligorCodingTotal && <TextUnderscore style={{ whiteSpace: "nowrap" }}>{formikProps.values.ObligorCodingTotal.toFixed(5) || '0.0000'}%</TextUnderscore>}
                    </Col>
                  </Row>
                )}

              <FileModal idOperation={props?.match?.params?.idOperation} file={file} />

              <FormContainer show={true} title={"ATTACHMENTS"}>
                <DragZoneUpload
                  autoUpload={true}
                  documentType={{
                    dsAnswerOption: "Payment Documents"
                  }}
                  fullHeight
                  multiple
                  documentTypeRequired={false}
                  onSuccess={(uploadedFiles) => {
                    setAttachments([...attachments, ...uploadedFiles]);
                    setUploading(true);
                  }}
                />
                {uploading && (
                  <>
                    <NewRowAttchments>
                      <Col md={12} sm={12}>
                        <TagsList3
                          small
                          tags={attachments.filter(file => file.fileName).map(file => ({ ...file, dsTypeDocument: file?.documentType?.dsAnswerOption, urlLink: file.fileUrl }))}
                          disableType
                          hideTrash={false}
                          removeTag={(index) => removeAttachment(index)}
                        />
                      </Col>
                    </NewRowAttchments>
                    {attachments.length > 0 && (
                      <div style={{ display: "flex", alignItems: "flex-end", justifyContent: "flex-end" }}>
                        <Button
                          style={{ marginTop: '1%', marginBottom: '1%' }}
                          primary
                          onClick={() => handleAttachments()}>
                          UPLOAD
                        </Button>
                      </div>
                    )}
                  </>
                )}
              </FormContainer>
              
              { attachmentsUploaded && (
              <Col md={12} sm={1} style={{ marginBottom: 20 }}>
              <Label>Attachment(s)</Label>
              <TagsList3
                tags={attachmentsUploaded.filter(file => file.nameFile)}
                disableType
                hideTrash={true}
              />
              </Col>
              )}

              <FilesAttachment signedDocs idOperation={props.match.params.idOperation} />

              <ButtonContainer>
                <Button forth onClick={() => history.goBack()}>&lt; Back</Button>
                <RenderButtons idOperation={props.match?.params?.idOperation}>
                  <ButtonContent>
                    <>
                      {endorsmentType ?
                        <>
                          <Button
                            style={{ marginLeft: "10px", marginTop: "5px" }}
                            primary
                            type="button"
                            id="btnPaymentConfiguration"
                            onClick={(e) => { e.preventDefault(); e.stopPropagation(); handlePaymentConfiguration() }}
                          >
                            REGENERATE PAYMENT DOCS
                          </Button>
                        </>
                        : null
                      }

                      <HasPermission permission={!endorsmentType && !summary.isFramework && props.permissions.PAYMENT_PACK_CREATE}>
                        <Button
                          style={{ marginLeft: "10px", marginTop: "5px" }}
                          third
                          id="btnSubmitSend"
                          onClick={(e) => { e.preventDefault(); e.stopPropagation(); handlePaymentConfig() }}
                        >
                          PAYMENT CONFIG.
                        </Button>
                      </HasPermission>

                      <HasPermission permission={!summary.isFramework && props.permissions.PAYMENT_PACK_SEND_INTERNALLY}>
                        <Button
                          style={{ marginLeft: "10px", marginTop: "5px" }}
                          primary
                          type="submit"
                          id="btnSubmitSend"
                          onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleSendApproval() }}
                        >
                          SEND APPROVAL
                        </Button>
                      </HasPermission>

                      {summary.isFramework && <Button
                        style={{ marginLeft: "10px", marginTop: "5px" }}
                        primary
                        type="submit"
                        id="btnSubmitSend"
                        onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleSendFramework() }}
                      >
                        CONFIRM LPAN
                      </Button>}
                    </>
                  </ButtonContent>
                </RenderButtons>
              </ButtonContainer>
            </Form>
          )}
        </Formik>
      </ContentCard>
      {loading.active && (<Loader backdropColor={Colors.WHITE} fullScreen />)}
    </Layout>
  );
}
